import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Assignment } from '../classes/assignment';
import { Observable } from 'rxjs';
import { Socket } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssignmentService {

  socket: Socket
  
  constructor(private httpClient: HttpClient) { }

  public get(assignmentId: number): Observable<Assignment> {
    return this.httpClient.get<Assignment>(`/api/media/assignments/${assignmentId}`);
  }

  public list(): Observable<Assignment[]> {
    return this.httpClient.get<Assignment[]>('/api/media/assignments');
  }

  initSocket(): void {
    this.socket = new Socket({
      url: environment.ws_url,
      options: {
        auth: {
          token: localStorage.getItem('media_access_token')
        }
      }
    })
  }

  listen(): Observable<any> {
    return this.socket.fromEvent('update')
  }

  picture(assignmentUUID: string): Observable<{ url: string }> {
    return this.httpClient.get<{ url: string }>(`/api/media/assignments/${assignmentUUID}/picture`)
  }

  productPicture(productUUID: number): Observable<{ url: string }> {
    return this.httpClient.get<{ url: string }>(`/api/media/products/${productUUID}/picture`)
  }

  update(assignmentUUID: string, prompt: string): Observable<any> {
    return this.httpClient.post<any>(`/api/media/assignments/${assignmentUUID}`, { 
      prompt 
    })
  }
}
